// extracted by mini-css-extract-plugin
export default {"link":"SingleLinkContainer_link__5GwvR","notActive":"SingleLinkContainer_notActive__wTBdl","children":"SingleLinkContainer_children__H9vYd"};